import React, {useEffect, useState} from 'react';
import IconButton from "@mui/material/IconButton";
import {Link} from "react-router-dom";
import Typography from "@mui/material/Typography";
import axios from "axios";

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function DashboardHomeButton() {

    const [title, setTitle] = useState("EquestriCraft")

    useEffect(() => {
        fetchTitle();
    }, []);

    const fetchTitle = async () => {
        const response = await axios.get('/dashboard/title');
        setTitle(response.data);
    };

    return (
        <IconButton
            size="large"
            color="inherit"
            type='button'
            style={{
                ...squareHighlightStyle,
                width: 'null',
                paddingLeft: '10px',
                paddingRight: '10px'
            }}
            component={Link}
            to="/"
        >
            <Typography variant="h6" component="div">
                {title}
            </Typography>
        </IconButton>
    );
}
